import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Private_Routes } from '../../../constants';
import { PayrollNoveltyFlowsForm } from '../components/forms/PayrollNoveltyFlowsForm';

export const CreatePayrollNoveltyFlows = () => {
    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row '>
                        <div className='col-12 p-3 py-0'>
                            <Helmet>
                                <title>Crear flujos de aprobación</title>
                            </Helmet>

                            <Breadcrumb>
                                <Breadcrumb.Item href={Private_Routes.HOME}>
                                    Inicio
                                </Breadcrumb.Item>
                                <Breadcrumb.Item
                                    href={Private_Routes.PAYROLL_NOVELTY_FLOWS.index}
                                >
                                    Flujos de aprobación
                                </Breadcrumb.Item>
                                <Breadcrumb.Item
                                    href={
                                        Private_Routes.PAYROLL_NOVELTY_FLOWS.create
                                    }
                                >
                                    Crear flujo de aprobación
                                </Breadcrumb.Item>
                            </Breadcrumb>

                            <Row>
                                <Col sm={12}>
                                    <Card>
                                        <Card.Header>
                                            <div className='d-flex gap-2 justify-content-between align-items-center'>
                                                <h5>Crear flujo de aprobación</h5>
                                            </div>
                                        </Card.Header>

                                        <Card.Body>
                                            <PayrollNoveltyFlowsForm isNew={true} />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
